<div class="footer py-3">
  <div class="footer-logo">
    <ingsv-adm-description-logo></ingsv-adm-description-logo>
  </div>
  <!-- <div class="text-center">
    <a [href]="getOldDesignLink()">Til gammel versjon</a>
  </div> -->
</div>